import Vue from "vue";
import Router from "vue-router";

import Home from "@/components/Home";
import DeveloperCommunity from "@/components/DeveloperCommunity";
import Information from "@/components/Information";
import InformationInfo from "@/components/InformationInfo";
import InformationInfoOne from "@/components/InformationInfoOne";
import Solution from "@/components/Solution";
import ProductSolution from "@/components/ProductSolution";
import AnSubPlatform from "@/components/AnSubPlatform";
import AboutUs from "@/components/AboutUs";
import Login from "@/components/Login";
import Register from "@/components/Register";
import ResetPWD from "@/components/resetPWD";
import EcoPartner from "@/components/EcoPartner";
import EcosystemJoint from "@/components/EcosystemJoint";
import DaliIndex from "@/components/DaliIndex";
import DaliComprehensive from "@/components/DaliComprehensive";
import ProductService from "@/components/ProductService";
import SolutionDetails from "@/components/SolutionDetails/index";
import ProductDetails from "@/components/ProductDetails/index";
import ConsultDetails from "@/components/ConsultDetails/index";
import ProductConsoleRJ from "@/components/ProductDetails/ProductConsoleRJ";
import ScreenDisplayRJ from "@/components/ProductDetails/mod_screen_display_show/allDisplay";

import Layout from "@/components/Layout";
import Console from "@/components/Console";
import DoOneGood from "@/components/DoOneGood";
import Message from "@/components/Message";
import MorningMeet from "@/components/MorningMeet";
import DayQing from "@/components/DayQing";
import Search from "../components/Search.vue";
import Password from "@/components/Password";
import UserInfo from "@/components/UserInfo.vue";
import ResetPhoneNumber from "@/components/ResetPhoneNumber.vue"
import ForestPwd from "@/components/ForestPwd.vue";

import CaseDetailCommon from "../components/CaseDetailCommon";
import CaseDetail from "../components/detail_page/CaseDetail";
import CaseTianjianDetail from "../components/detail_page/CaseTianjianDetail";
import CaseTianjianDetail1 from "../components/detail_page/CaseTianjianDetail1";
import CaseNanjingDetail from "../components/detail_page/CaseNanjingDetail";
import CaseTaidiDetail from "@/components/detail_page/CaseTaidiDetail";
import CaseShengHeDetail from "@/components/detail_page/CaseShengHeDetail";
import CaseWeierliDetail1 from "@/components/detail_page/CaseWeierliDetail1";
import CaseWeierliDetail2 from "@/components/detail_page/CaseWeierliDetail2";
import CaseZhongZaiShengDetail0 from "@/components/detail_page/CaseZhongZaiShengDetail0";
import CaseZhongZaiShengDetail1 from "@/components/detail_page/CaseZhongZaiShengDetail1";
import CaseZhongZaiShengDetail2 from "@/components/detail_page/CaseZhongZaiShengDetail2";
import CaseZhongZaiShengDetail3 from "@/components/detail_page/CaseZhongZaiShengDetail3";
import CaseZhongZaiShengDetail4 from "@/components/detail_page/CaseZhongZaiShengDetail4";
import CaseCfznsyDetail from "../components/detail_page/CaseCfznsyDetail";
import CaseZjnxhjjDetail from "../components/detail_page/CaseZjnxhjjDetail";
import CaseZjnznhDetail from "../components/detail_page/CaseZjnznhDetail";
import DeveloperDetail from "../components/detail_page/DeveloperDetail";
import DeveloperDsjDetail from "../components/detail_page/DeveloperDsjDetail";
import DeveloperDzxDetail from "../components/detail_page/DeveloperDzxDetail";
import DeveloperGyhlwDetail from "../components/detail_page/DeveloperGyhlwDetail";
import DeveloperJqxxDetail from "../components/detail_page/DeveloperJqxxDetail";


const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

Vue.use(Router);

export default new Router({
  mode: "history", //去掉url中的#
  routes: [
    {
      path: "/",
      name: "Home",
      component: Home,
      meta: {
        title: "Eiiplat环境产业互联网平台",
        content: {
          keywords:
            "环保一体化，环卫一体化解决方案，环保智能收运系统，环卫智能收运系统，餐厨智能化，环保智能设计，环保智能施工，环保智能管控，环境产业平台，环境工业互联网平台，餐厨厨余智能化，餐厨垃圾智能化收运，餐厨垃圾智能收运解决方案，餐厨垃圾施工管理系统，环保产业应用市场，智能供应系统，智能设计系统，环保财务咨询系统，OKR管理系统，青岛国真智慧，农村厕改智能管护系统",
          description:
            "青岛国真智慧Eiiplat环境产业物联网平台是国内首家环境产业工业互联网平台。Eiiplat平台致力于服务环境产业固废、污水、大气、噪音、辐射五大行业，其中以固废切入点，打造了智能设计、智能供应、施工管理、智能收运、智能管控 、机制管理、财务管理、OKR管理八大应用，赋能行业转型升级。利用资金流驱动废弃物的循环流动，优化过程数据提高效率，对废弃物全生命周期追溯，为客户提高生产效率和降低运营成本提供持续的解决方案。"
        }
      }
    },
    {
      path: "/DeveloperCommunity",
      name: "DeveloperCommunity",
      component: DeveloperCommunity,
      meta: {
        title: "Eiiplat环境产业互联网平台开发者社区",
        content: {
          keywords: "Eiiplat环境产业互联网平台开发者社区",
          description: "Eiiplat环境产业互联网平台开发者社区"
        }
      }
    },
    {
      path: "/Information",
      name: "Information",
      component: Information,
      meta: {
        title: "Eiiplat环境产业互联网平台平台资讯",
        content: {
          keywords:
            "Eiiplat环境产业互联网平台平台资讯，行业最新动态，市场活动，环保行业动态，青岛国真智慧",
          description:
            "Eiiplat环境产业互联网平台平台资讯，行业最新动态，市场活动，环保行业动态，青岛国真智慧"
        }
      }
    },
    {
      path: "/Information/info",
      name: "InformationInfo",
      component: InformationInfo
    },
    {
      path: "/Information/infoone",
      name: "InformationInfoOne",
      component: InformationInfoOne
    },
    {
      path: "/Solution",
      name: "Solution",
      component: Solution,
      meta: {
        title:
          "Eiiplat环境产业互联网平台解决方案，环卫智能化解决方案，环保智能化解决方案，大平台",
        content: {
          keywords:
            "环卫一体化智能解决方案，环境产业平台解决方案，智能施工解决方案，智能设计解决方案，智能收运解决方案，智能供应解决方案，智能管控解决方案，农村厕改智能管护系统解决方案，餐厨垃圾智能收运解决方案，餐厨垃圾施工管理系统。",
          description:
            "青岛国真智慧Eiiplat环境产业物联网平台是国内首家环境产业工业互联网平台。提供环卫一体化智能解决方案，环境产业平台解决方案，智能施工解决方案，智能设计解决方案，智能收运解决方案，智能供应解决方案，智能管控解决方案，农村厕改智能管护系统解决方案，餐厨垃圾智能收运解决方案，餐厨垃圾施工管理系统。 、机制管理、财务管理、OKR管理八大应用，赋能行业转型升级。利用资金流驱动废弃物的循环流动，优化过程数据提高效率，对废弃物全生命周期追溯，为客户提高生产效率和降低运营成本提供持续的解决方案。"
        }
      }
    },
    {
      path: "/SolutionDetails",
      name: "SolutionDetails",
      component: SolutionDetails
    },
    {
      path: "/ProductDetails",
      name: "ProductDetails",
      component: ProductDetails
    },
    {
      path: "/ProductConsoleRJ",
      name: "ProductConsoleRJ",
      component: ProductConsoleRJ
    },
    {
      path: "/ScreenDisplayRJ",
      name: "ScreenDisplayRJ",
      component: ScreenDisplayRJ
    },
    {
      path: "/EcosystemJoint",
      name: "EcosystemJoint",
      component: EcosystemJoint
    },
    {
      path: "/DaliIndex",
      name: "DaliIndex",
      component: DaliIndex
    },
    {
      path: "/DaliComprehensive",
      name: "DaliComprehensive",
      component: DaliComprehensive
    },
    {
      path: "/ConsultDetails",
      name: "ConsultDetails",
      component: ConsultDetails
    },
    {
      path: "/ProductSolution",
      name: "ProductSolution",
      component: ProductSolution
    },
    {
      path: "/AnSubPlatform",
      name: "AnSubPlatform",
      component: AnSubPlatform
    },
    {
      path: "/AboutUs",
      name: "AboutUs",
      component: AboutUs,
      meta: {
        title: "Eiiplat环境产业互联网平台关于我们",
        content: {
          keywords:
            "青岛国真智慧Eiiplat环境产业物联网平台是国内首家环境产业工业互联网平台。Eiiplat平台致力于服务环境产业固废、污水、大气、噪音、辐射五大行业，其中以固废切入点，打造了智能设计、智能供应、施工管理、智能收运、智能管控 、机制管理、财务管理、OKR管理八大应用，赋能行业转型升级。",
          description:
            "青岛国真智慧Eiiplat环境产业物联网平台是国内首家环境产业工业互联网平台。Eiiplat平台致力于服务环境产业固废、污水、大气、噪音、辐射五大行业，其中以固废切入点，打造了智能设计、智能供应、施工管理、智能收运、智能管控 、机制管理、财务管理、OKR管理八大应用，赋能行业转型升级。利用资金流驱动废弃物的循环流动，优化过程数据提高效率，对废弃物全生命周期追溯，为客户提高生产效率和降低运营成本提供持续的解决方案。 、机制管理、财务管理、OKR管理八大应用，赋能行业转型升级。利用资金流驱动废弃物的循环流动，优化过程数据提高效率，对废弃物全生命周期追溯，为客户提高生产效率和降低运营成本提供持续的解决方案。"
        }
      }
    },
    {
      path: "/login",
      name: "Login",
      component: Login
    },
    {
      path: "/register",
      component: Register
    },
    {
      path: "/resetPWD",
      component: ResetPWD
    },
    {
      path: "/userInfo",
      component: UserInfo
    },
    {
      path: "/forestPwd",
      component: ForestPwd
    },
    {
      path: "/resetPhoneNumber",
      component: ResetPhoneNumber
    },
    {
      path: "/console",
      redirect: "/console/index",
      component: Layout,
      children: [
        {
          path: "index",
          component: Console
        },
        {
          path: "password",
          component: Password
        }
      ]
    },
    {
      path: "/Search",
      name: "Search",
      component: Search
    },
    {
      path: "/solition_lower",
      name: "CaseDetailCommon",
      component: CaseDetailCommon
    },
    {
      path: "/solition_lower/CaseDetail",
      name: "CaseDetail",
      component: CaseDetail
    },
    {
      path: "/solition_lower/CaseZjnznhDetail",
      name: "CaseZjnznhDetail",
      component: CaseZjnznhDetail
    },
    {
      path: "/solition_lower/CaseNanjingDetail",
      name: "CaseNanjingDetail",
      component: CaseNanjingDetail
    },
    {
      path: "/solition_lower/CaseZjnxhjjDetail",
      name: "CaseZjnxhjjDetail",
      component: CaseZjnxhjjDetail
    },
    {
      path: "/solition_lower/CaseWeierliDetail1",
      name: "CaseWeierliDetail1",
      component: CaseWeierliDetail1
    },
    {
      path: "/solition_lower/CaseWeierliDetail2",
      name: "CaseWeierliDetail2",
      component: CaseWeierliDetail2
    },
    {
      path: "/detail_page/CaseTianjianDetail",
      name: "CaseTianjianDetail",
      component: CaseTianjianDetail
    },
    {
      path: "/detail_page/CaseZhongZaiShengDetail0",
      name: "CaseZhongZaiShengDetail0",
      component: CaseZhongZaiShengDetail0
    },
    {
      path: "/detail_page/CaseZhongZaiShengDetail1",
      name: "CaseZhongZaiShengDetail1",
      component: CaseZhongZaiShengDetail1
    },
    {
      path: "/detail_page/CaseZhongZaiShengDetail2",
      name: "CaseZhongZaiShengDetail2",
      component: CaseZhongZaiShengDetail2
    },
    {
      path: "/detail_page/CaseZhongZaiShengDetail3",
      name: "CaseZhongZaiShengDetail3",
      component: CaseZhongZaiShengDetail3
    },
    {
      path: "/detail_page/CaseZhongZaiShengDetail4",
      name: "CaseZhongZaiShengDetail4",
      component: CaseZhongZaiShengDetail4
    },
    {
      path: "/detail_page/CaseTianjianDetail1",
      name: "CaseTianjianDetail1",
      component: CaseTianjianDetail1
    },
    {
      path: "/detail_page/CaseTaidiDetail",
      name: "CaseTaidiDetail",
      component: CaseTaidiDetail
    },
    {
      path: "/detail_page/CaseShengHeDetail",
      name: "CaseShengHeDetail",
      component: CaseShengHeDetail
    },
    {
      path: "/solition_lower/CaseCfznsyDetail",
      name: "CaseCfznsyDetail",
      component: CaseCfznsyDetail
    },
    {
      path: "/detail_page/DeveloperDetail",
      name: "DeveloperDetail",
      component: DeveloperDetail
    },
    {
      path: "/detail_page/DeveloperDsjDetail",
      name: "DeveloperDsjDetail",
      component: DeveloperDsjDetail
    },
    {
      path: "/detail_page/DeveloperDzxDetail",
      name: "DeveloperDzxDetail",
      component: DeveloperDzxDetail
    },
    {
      path: "/detail_page/DeveloperGyhlwDetail",
      name: "DeveloperGyhlwDetail",
      component: DeveloperGyhlwDetail
    },
    {
      path: "/detail_page/DeveloperJqxxDetail",
      name: "DeveloperJqxxDetail",
      component: DeveloperJqxxDetail
    },
    {
      path: "/EcoPartner",
      name: "EcoPartner",
      component: EcoPartner
    },
    // 查看规则、
    {
      path: "/file",
      component: () => import("@/components/file")
    },
    {
      path: "/ProductService",
      name: "ProductService",
      component: ProductService
    },
    {
      path: "/DoOneGood",
      name: "DoOneGood",
      component: Layout,
      children:[
        {
          path: "index",
          component: DoOneGood
        },
      ]
    },
    {
      path: "/Message",
      name: "Message",
      component: Layout,
      children:[
        {
          path: "index",
          component: Message
        },
      ]
    },
    {
      path: "/MorningMeet",
      name: "MorningMeet",
      component: Layout,
      children:[
        {
          path: "index",
          component: MorningMeet
        },
      ]
    },
    {
      path: "/DayQing",
      name: "DayQing",
      component: Layout,
      children:[
        {
          path: "index",
          component: DayQing
        },
      ]
    },
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js